<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

import {SmartOfferBundleAchievementType} from "@/modules/redactor/models/smart-offer/bundle-achievement/SmartOfferBundleAchievementType";

export default {
  name: "r-smart-offer-bundle-achievement-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleAchievementType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleAchievementType.getValues();
    }
  }
}
</script>